import * as React from 'react';
import styled from 'styled-components';
import MuiGrid, { GridProps as MuiGridProps } from '@material-ui/core/Grid';

import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';

const usePrintStyles = makeStyles({
    'PrintGrid-1': {
        '@media print': {
            flexBasis: '8.333333% !important',
            flexGrow: '0 !important',
            maxWidth: '8.333333% !important',
        },
    },
    'PrintGrid-10': {
        '@media print': {
            flexBasis: '83.333333% !important',
            flexGrow: '0 !important',
            maxWidth: '83.333333% !important',
        },
    },
    'PrintGrid-11': {
        '@media print': {
            flexBasis: '91.666667% !important',
            flexGrow: '0 !important',
            maxWidth: '91.666667% !important',
        },
    },
    'PrintGrid-12': {
        '@media print': {
            flexBasis: '100% !important',
            flexGrow: '0 !important',
            maxWidth: '100% !important',
        },
    },
    'PrintGrid-2': {
        '@media print': {
            flexBasis: '16.666667% !important',
            flexGrow: '0 !important',
            maxWidth: '16.666667% !important',
        },
    },
    'PrintGrid-3': {
        '@media print': {
            flexBasis: '25% !important',
            flexGrow: '0 !important',
            maxWidth: '25% !important',
        },
    },
    'PrintGrid-4': {
        '@media print': {
            flexBasis: '33.333333% !important',
            flexGrow: '0 !important',
            maxWidth: '33.333333% !important',
        },
    },
    'PrintGrid-5': {
        '@media print': {
            flexBasis: '41.666667% !important',
            flexGrow: '0 !important',
            maxWidth: '41.666667% !important',
        },
    },
    'PrintGrid-6': {
        '@media print': {
            flexBasis: '50% !important',
            flexGrow: '0 !important',
            maxWidth: '50% !important',
        },
    },
    'PrintGrid-7': {
        '@media print': {
            flexBasis: '58.333333% !important',
            flexGrow: '0 !important',
            maxWidth: '58.333333% !important',
        },
    },
    'PrintGrid-8': {
        '@media print': {
            flexBasis: '66.666667% !important',
            flexGrow: '0 !important',
            maxWidth: '66.666667% !important',
        },
    },
    'PrintGrid-9': {
        '@media print': {
            flexBasis: '75% !important',
            flexGrow: '0 !important',
            maxWidth: '75% !important',
        },
    },
    'PrintGrid-auto': {
        '@media print': {
            flexBasis: 'auto !important',
            flexGrow: '0 !important',
            maxWidth: 'none !important',
        },
    },
    'PrintGrid-true': {
        '@media print': {
            flexBasis: '0 !important',
            flexGrow: '1 !important',
            maxWidth: '100% !important !important',
        },
    },
});

const StyledGrid = styled(MuiGrid)``;
export type DSGridProps = Omit<MuiGridProps, 'component'> & {
    pr?: MuiGridProps['xs'];
};
export const DSGrid: React.FC<DSGridProps> = React.forwardRef(({ className, pr, ...props }: DSGridProps, ref) => {
    const styles = usePrintStyles();
    return (
        <StyledGrid
            className={classNames(className, pr ? (styles as any)[`PrintGrid-${pr.valueOf().toString()}`] : false)}
            ref={ref as any}
            {...props}
        />
    );
}) as any;
DSGrid.displayName = 'DSGrid';
